import axios from '@/api/config';

const paymentSetting = {
  addPaymentSetting(data) {
    return axios.post(`${process.env.BASE_URL}/paymentSetting/addPaymentSetting`, data);
  },
  updatePaymentSetting(data) {
    return axios.put(`${process.env.BASE_URL}/paymentSetting/updatePaymentSetting`, data);
  },
  getPaymentSetting(data) {
    return axios.get(`${process.env.BASE_URL}/paymentSetting/getPaymentSetting`, {params:data});
  },
}

export default paymentSetting;



// WEBPACK FOOTER //
// ./src/api/paymentSetting.js